import React from "react";
import Link from "next/link";

// Next.js router
import { useRouter } from "next/router";

// Other components

import Iconify from "../iconify";
import IconCode from "@/src/lib/iconCode";
import useBreakpoint from "@/src/lib/util/custom-hooks/useBreakPoint";
import CustomTooltip from "@/src/lib/ui/customTooltip";
import TatByCity from "@/src/components/common/tat/tatByCity";

const InfoIcon = ({ icon }) => (
    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary/5 ring-1 ring-primary/10">
        <Iconify icon={icon} width={20} className="text-primary" />
    </span>
);

const TestInfo = ({ testDetails, testVariantDetails, isLoading }) => {
    const isMobile = useBreakpoint("sm");

    const router = useRouter();
    const specializations =
        testDetails?.configProductCard?.specializations || [];
    const defaultTat = testVariantDetails?.reportingBy;
    const testPreparation = testVariantDetails?.testPreparation || "";

    const handleClick = (urlSlug) => {
        router.push(`/specialization/${urlSlug}`);
    };

    const cityByTat = testDetails?.configProductCard?.tatByCityId;

    return (
        <section className="rounded-xl border border-slate-200 bg-white shadow-sm divide-y divide-slate-100">
            {/* Test Preparation Section */}
            <div className="flex gap-4 p-5 md:p-6">
                <InfoIcon icon="material-symbols:assignment-outline-rounded" />
                <div className="min-w-0 flex-1">
                    <h3 className="text-sm font-semibold text-slate-900">
                        Test Preparation
                    </h3>

                    <div
                        className="mt-1 text-sm leading-6 text-slate-600 [&_p]:text-slate-600 [&_p]:leading-6 [&_span]:text-slate-600 [&_div]:text-slate-600"
                        dangerouslySetInnerHTML={{
                            __html: testPreparation || "",
                        }}
                    ></div>
                </div>
            </div>

            {/* Reporting TAT Section */}
            <div className="flex gap-4 p-5 md:p-6">
                <InfoIcon icon="material-symbols:schedule-outline-rounded" />
                <div className="min-w-0 flex-1">
                    <h3 className="text-sm font-semibold text-slate-900">
                        Reporting TAT
                    </h3>
                    <div className="mt-1 relative inline-block">
                        <CustomTooltip
                            title="Valid for tests collected in Delhi before 3PM."
                            placement={isMobile ? "top-start" : "right"}
                            arrow={true}
                        >
                            <span className="inline-flex items-center gap-1.5 cursor-help">
                                <TatByCity
                                    tat={cityByTat}
                                    className="text-sm font-medium text-slate-700"
                                />
                                <Iconify
                                    icon={IconCode.biInfoCircle}
                                    width={16}
                                    className="text-slate-400"
                                />
                            </span>
                            {/* <span>{defaultTat}</span> */}
                        </CustomTooltip>
                    </div>
                </div>
            </div>

            {specializations?.length > 0 && (
                <div className="flex gap-4 p-5 md:p-6">
                    <InfoIcon icon="material-symbols:stethoscope-rounded" />
                    <div className="min-w-0 flex-1">
                        <h3 className="text-sm font-semibold text-slate-900">
                            Specializations
                        </h3>
                        <div className="mt-2 flex flex-row flex-wrap items-center gap-2">
                            {specializations?.map((item, index) => (
                                <Link
                                    key={index}
                                    href={`/specialization/${item.urlSlug}`}
                                    title={item.specializationName}
                                    className="rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30"
                                >
                                    <span className="inline-flex items-center rounded-full border border-slate-200 bg-white px-3 py-1 text-xs md:text-sm font-medium text-slate-700 transition-colors hover:border-primary/40 hover:bg-primary/5 hover:text-primary">
                                        {item.specializationName}
                                    </span>
                                </Link>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
};

export default TestInfo;
